<script>
  import { getNotificationsContext } from "svelte-notifications";
  import { useQuery, useQueryClient } from "@sveltestack/svelte-query"
  import Section from "../../../components/layout/Section.svelte";
  import SectionTitle from "../../../components/layout/SectionTitle.svelte";
  import SectionCaption from "../../../components/layout/SectionCaption.svelte";
  import SectionSeparator from "../../../components/layout/SectionSeparator.svelte";
  import Stack from "../../../components/layout/Stack.svelte";
  import Button from "../../../components/button/Button.svelte";
  import { getAutoMpsProjectContext } from "../../AutoMpsProjectContext.js";
  import HelpTooltip from "../../../components/tooltip/HelpTooltip.svelte";
  import ToggleSwitch from "../../../components/input/ToggleSwitch.svelte";

  const ctx = getAutoMpsProjectContext()
  const {addNotification} = getNotificationsContext()

  const queryClient = useQueryClient()
  const query = useQuery(`/api/auto-mps/projects/${$ctx.projectId}/settings/asprova`)

  let isSubmitting = false
  async function onClickImportDataForDemo() {
    const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/demo/setup-data`, {method: "POST"})
    if (response.ok) {
      addNotification({
        text: "デモ用にデータをインポートしました。",
        type: "success",
        removeAfter: 4000,
        position: "top-right",
      })
    } else {
      addNotification({
        text: "インポートに失敗しました",
        type: "error",
        removeAfter: 4000,
        position: "top-right",
      })
    }
  }

  async function onClickEnableDemo() {
    const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/demo/enable`, {method: "POST"})
    if (response.ok) {
      addNotification({
        text: "デモを有効にしました。",
        type: "success",
        removeAfter: 4000,
        position: "top-right",
      })
      await queryClient.invalidateQueries(`/api/auto-mps/projects/${$ctx.projectId}/settings/asprova`)
    } else {
      addNotification({
        text: "有効化に失敗しました。",
        type: "error",
        removeAfter: 4000,
        position: "top-right",
      })
    }
  }

  async function onClickDisableDemo() {
    const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/demo/disable`, {method: "POST"})
    if (response.ok) {
      addNotification({
        text: "デモを無効にしました。",
        type: "success",
        removeAfter: 4000,
        position: "top-right",
      })
      await queryClient.invalidateQueries(`/api/auto-mps/projects/${$ctx.projectId}/settings/asprova`)
    } else {
      addNotification({
        text: "無効化に失敗しました。",
        type: "error",
        removeAfter: 4000,
        position: "top-right",
      })
    }
  }

  async function toggleDemoMode(toggledValue) {
    isSubmitting = true
    if (toggledValue) {
      await onClickEnableDemo()
    } else {
      await onClickDisableDemo()
    }
    isSubmitting = false
  }
</script>

<Section>
  <SectionTitle>デモ設定</SectionTitle>
  <SectionCaption>デモ用にデータをセットアップします。</SectionCaption>
  <SectionSeparator />
  <Stack direction="vertical">
    <Stack direction="horizontal" alignItems="center">
      <span>
        デモモード
        <HelpTooltip title="デモモード">
          デモモードが有効なとき、データをインポートする設定画面や、平準化の設定画面が利用できるようになります。
          デモモードを利用するには、デモモード向けのAruファイルが使用される必要があります。
        </HelpTooltip>
      </span>
      :
      <ToggleSwitch
        disabled={isSubmitting}
        on={$query.data?.demo}
        onChange={e => toggleDemoMode(e.target.checked)}
      />
    </Stack>
    <Stack direction="horizontal" alignItems="center">
      マッピング定義、平準化用データをインポートする
      <Button type="primary" disabled={!($query.data?.demo) || isSubmitting} onClick={onClickImportDataForDemo}>
        インポート
      </Button>
    </Stack>
  </Stack>
</Section>
